// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__XMdsc","low":"Button_low__NTB6F"};